export function rgbHex(rawHex) {
  // validate hex string
  let hex = String(rawHex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  return hex;
}

export function rgbValues(rawHex) {
  const hex = rgbHex(rawHex);
  // map RGB values to variables
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  let a = 1;

  if (hex[6]) {
    a = parseInt(hex.split(',')[3], 16);
  }

  return {
    r,
    g,
    b,
    a,
  };
}

export function rgbToCss(rgb) {
  return `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`;
}

export function contrast(rawHex) {
  const { r, g, b } = rgbValues(rawHex);
  // calculate contrast of color (standard grayscale algorithmic formula)
  return (Math.round(r * 299) + Math.round(g * 587) + Math.round(b * 114)) / 1000;
}

export function colorLuminance(rawHex, lum = 0) {
  const hex = rgbHex(rawHex);

  // convert to decimal and change luminosity
  let rgb = '#';
  let c;
  let i;
  for (i = 0; i < 3; i += 1) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
    rgb += (`00${c}`).substr(c.length);
  }
  return rgb;
}

export function contrastingColor(rawHex) {
  // 128 is the recommend value, but I'm finding that a slightly higher value is better.
  return (contrast(rawHex) >= 140) ? '#000000' : '#FFFFFF';
}

export function deriveColors(color) {
  return {
    lightColor: colorLuminance(color, 0.4),
    highLightColor: color,
    buttonColor: contrastingColor(color),
  };
}
